import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import Documento from './components/Documentos';
import { Toaster } from 'react-hot-toast';

export default function Documentos() {

    return (
        <MainContent component={ <Documento /> } titulo='Documentos' >
        </MainContent>   
             
    );

};